import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import { loadNGUMStatus, toggleNGUM } from "../actions";
import { PrimaryButton, SecondaryButton } from "../../../components/Buttons";
import ConfirmationDialog from "../../../components/ConfirmationDialog";

const frontload = async (props) => {
  await props.getNGUMStatus();
};
const mapStateToProps = (state) => {
  return {
    isActive: state.ngum.isNGUMActive,
  };
};
const mapDispatchToProps = (dispatch) => ({
  getNGUMStatus: (...args) => dispatch(loadNGUMStatus(...args)),
  toggleNGUMStatus: (...args) => dispatch(toggleNGUM(...args)),
});

function NGUMSwitchPanel({ className = "", isActive, toggleNGUMStatus }) {
  const confirmationDialogRef = React.useRef(null);

  const onToggleNGUM = React.useCallback(() => {
    const message = `Wollen Sie nGUM wirklich ${isActive ? "aus" : "ein"}schalten?`;
    confirmationDialogRef.current.show(
      true,
      {
        title: `nGUM ${isActive ? "aus" : "ein"}schalten`,
        text: message,
      },
      () => toggleNGUMStatus(),
    );
  }, [isActive, toggleNGUMStatus]);

  const Button = isActive ? SecondaryButton : PrimaryButton;
  const buttonText = isActive ? "Ausschalten" : "Einschalten";

  return (
    <div className={`w3-border ${className}`}>
      <p className="pad-big">{`Hier können Sie die Kommunikation mit nGUM ein-/ausschalten und somit die Funktionsweise des AN-Portals anpassen.`}</p>
      <div className="w3-border-top pad-big">
        <ItemHolder>
          <Item>
            <h3>nGUM</h3>
          </Item>
          <Arrow connected={isActive} />
          <Item>
            <h3>AN-Portal</h3>
          </Item>
        </ItemHolder>
      </div>
      <div
        className="w3-border-top- pad-big-btm"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          onClick={onToggleNGUM}
          style={{ position: "relative", top: "-1.5em" }}
          disabled={window && window.ENABLE_NGUM_SWITCH === "NO" ? true : false}
        >
          {buttonText}
        </Button>
      </div>
      <ConfirmationDialog ref={confirmationDialogRef} />
    </div>
  );
}

NGUMSwitchPanel.propTypes = {
  className: PropTypes.string,
  getNGUMStatus: PropTypes.func.isRequired,
  toggleNGUMStatus: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(NGUMSwitchPanel),
);

const ItemHolder = ({ children }) => (
  <div
    className="pad-lg"
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "2em",
    }}
  >
    {children}
  </div>
);

const Item = ({ children }) => (
  <div
    className="w3-border w3-round pad-lg"
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: "10em",
    }}
  >
    {children}
  </div>
);

const Arrow = ({ connected, width = 10 }) => (
  <div
    className={` w3-${connected ? "green" : "grey"} pos-rel`}
    style={{
      width: `${width}em`,
      height: "1.5em",
    }}
  >
    <div
      className={`arrow-inner w3-border-${connected ? "green" : "grey"}`}
      style={{
        borderStyle: "solid",
        borderWidth: "0 1em 1em 0",
        display: "inline-block",
        padding: "1em",
        transform: "rotate(-45deg)",
        WebkitTransform: "rotate(-45deg)",
        position: "absolute",
        top: "-0.74em",
        right: "-0.12em",
      }}
    />
    {!connected && (
      <div
        className="arrow-inner w3-white"
        style={{
          width: "1em",
          height: "4em",
          position: "absolute",
          top: "-1.25em",
          left: `${width / 2 - 0.5}em`,
          transform: "rotate(45deg)",
        }}
      />
    )}
  </div>
);
